// extracted by mini-css-extract-plugin
export default {"containerform":"todoList_containerform__NwqG2","todoContainer":"todoList_todoContainer__RSon7","btn":"todoList_btn__m+oQv"};